import {
  SYNCHRONIZE_REQUEST,
  SYNCHRONIZE_SUCCESS,
  SYNCHRONIZE_FAILURE,
  SYSTEM_INFO_GET_REQUEST,
  SYSTEM_INFO_GET_SUCCESS,
  SYSTEM_INFO_GET_FAILURE,
  SYNCHRONIZATION_DETAILS_GET_REQUEST,
  SYNCHRONIZATION_DETAILS_GET_SUCCESS,
  SYNCHRONIZATION_DETAILS_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

function synchronize(dateFrom, dateTo) {
  return {
    types: [SYNCHRONIZE_REQUEST, SYNCHRONIZE_SUCCESS, SYNCHRONIZE_FAILURE],
    shouldCallAPI: () => true,
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      data: {
        synchronizeFrom: dateFrom,
        synchronizeTo: dateTo,
      },
      path: 'v1/command/ApiRequestFullSynchronization',
    }),
  };
}

function getSystemInfo() {
  return {
    types: [SYSTEM_INFO_GET_REQUEST, SYSTEM_INFO_GET_SUCCESS, SYSTEM_INFO_GET_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: 'v1/query/GetSystemInfo',
    }),
  };
}

function getSynchronizationDetails() {
  return {
    types: [
      SYNCHRONIZATION_DETAILS_GET_REQUEST,
      SYNCHRONIZATION_DETAILS_GET_SUCCESS,
      SYNCHRONIZATION_DETAILS_GET_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: 'v1/query/GetSynchronizationDetails',
    }),
  };
}

export { synchronize, getSystemInfo, getSynchronizationDetails };
